import {restapi, sockapi, HttpErrorHandler} from './http'
import SessionService from './session'
import ModalService from './modal-service'
import CodeService from './code'
import MainFrame from '@/components/MainLayout'

const filterDuraltionToTimeFormat = (duration) => {
    let result = '00:00:00'
    let n = parseInt(duration, 10)
    if (isNaN(n)) return result
    
    n = Math.ceil(n / 1000)
    result = String(Math.floor(n / 3600)).padStart(2, '0')
    n = n % 3600

    result += ':' + String(Math.floor(n / 60)).padStart(2, '0')
    result += ':' + String(Math.floor(n % 60)).padStart(2, '0')
    return result
}
 
export default {
    install (Main) {
        Main.prototype.$http = restapi
        Main.prototype.$sock = sockapi
        Main.prototype.$session = SessionService
        Main.prototype.$modal = ModalService
        Main.prototype.$code = CodeService
        Main.prototype.$httpErrorHandler = HttpErrorHandler(Main)
        Main.prototype.$timezone = (new Date().getTimezoneOffset() * -1) + ' m'
        Main.component('main-layout', MainFrame)
        Main.filter('durtotime', filterDuraltionToTimeFormat)
    }
}